import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const PropertyFeesAndTaxesContainerStyled = styled.div`
  .column-appliesTo,
  .column-scope {
    width: 150px;
  }
  .column-name {
    width: 250px;
  }

  ${mediaQuery.md} {
    .column-appliesTo,
    .column-scope {
      width: 100px;
    }
    .column-name {
      width: 200px;
    }
  }

  ${mediaQuery.xs} {
    .table {
      min-width: 1000px;
    }
  }
`;
